/* Import External Modules */
import React from 'react';
import PropTypes from 'prop-types';

/* Import Leverege Modules */
import { Label, Flex, Text, FileInput, Toast } from '@leverege/ui-elements';

/* Initialize Constants */
// const ACCEPTED_MIME_TYPES = [ 'text/csv', 'application/vnd.ms-excel' ]
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ACCEPTED_EXTENSIONS = ['.csv'];

/**
 * Uploader.
 */
export default class Uploader extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    eventData: PropTypes.string
  };
  static defaultProps = {
    onChange: () => {},
    eventData: 'csv'
  };
  onCSVSelect = async event => {
    const {
      onChange,
      eventData,
      onClose
    } = this.props;
    const file = event?.value[0];

    // const type = file.type
    if (!ACCEPTED_EXTENSIONS.some(val => file.name.endsWith(val))) {
      Toast.error('File type is not in a supported format. Supported formats are .csv.');
      onClose();
      return;
    }
    if (typeof onChange === 'function') {
      onChange({
        data: eventData,
        value: {
          file
        }
      });
    }
  };
  render() {
    const {
      file,
      eventData
    } = this.props;
    return /*#__PURE__*/_jsxs(Flex, {
      variant: "colS",
      children: [/*#__PURE__*/_jsx(Label, {
        variant: "inputTitle",
        children: "Upload File"
      }), /*#__PURE__*/_jsxs(Flex, {
        variant: "rowS",
        align: "center",
        children: [/*#__PURE__*/_jsx(FileInput, {
          variant: "secondary",
          eventData: eventData,
          fileTypes: ACCEPTED_EXTENSIONS,
          onChange: this.onCSVSelect,
          children: "Choose File"
        }), file?.name && /*#__PURE__*/_jsx(Text, {
          variant: "logUploadFileName",
          style: {
            paddingLeft: '4px'
          },
          children: file.name
        })]
      })]
    });
  }
}